import { requireMenu } from '../../auth/guards';
import BooksSettingsPage from './pages/BooksSettingsPage';
import CashBankBookPage from './pages/CashBankBookPage';
import DayBookPage from './pages/DayBookPage';
import GroupsPage from './pages/GroupsPage';
import LedgerBookPage from './pages/LedgerBookPage';
import LedgersPage from './pages/LedgersPage';
import TrialBalancePage from './pages/TrialBalancePage';
import VouchersPage from './pages/VouchersPage';

/** Accounts: double-entry books per company (V29), gated by the role's menu grants (V30). */
export const accountingRoutes = [
  {
    path: '/accounts/vouchers',
    element: <VouchersPage />,
    handle: { breadcrumb: 'Vouchers' },
    loader: requireMenu('accounts.vouchers'),
  },
  {
    path: '/accounts/ledgers',
    element: <LedgersPage />,
    handle: { breadcrumb: 'Ledgers' },
    loader: requireMenu('accounts.ledgers'),
  },
  {
    path: '/accounts/groups',
    element: <GroupsPage />,
    handle: { breadcrumb: 'Ledger Groups' },
    loader: requireMenu('accounts.groups'),
  },
  {
    path: '/accounts/day-book',
    element: <DayBookPage />,
    handle: { breadcrumb: 'Day Book' },
    loader: requireMenu('accounts.day-book'),
  },
  {
    path: '/accounts/cash-book',
    element: <CashBankBookPage key='cash' kind='CASH' />,
    handle: { breadcrumb: 'Cash Book' },
    loader: requireMenu('accounts.cash-book'),
  },
  {
    path: '/accounts/bank-book',
    element: <CashBankBookPage key='bank' kind='BANK' />,
    handle: { breadcrumb: 'Bank Book' },
    loader: requireMenu('accounts.bank-book'),
  },
  {
    path: '/accounts/ledger-book',
    element: <LedgerBookPage />,
    handle: { breadcrumb: 'Ledger Book' },
    loader: requireMenu('accounts.ledger-book'),
  },
  {
    path: '/accounts/trial-balance',
    element: <TrialBalancePage />,
    handle: { breadcrumb: 'Trial Balance' },
    loader: requireMenu('accounts.trial-balance'),
  },
  {
    path: '/accounts/settings',
    element: <BooksSettingsPage />,
    handle: { breadcrumb: 'Books Settings' },
    loader: requireMenu('admin.books-settings'),
  },
];
